import {
  DriverLocation,
  GetOrderRequest,
  GetOrdersResponse,
  GetServiceOptionsResponse,
  Order,
  RequestSupportBody,
  UpdateOrderBody,
  UpsertReviewBody,
  UpsertReviewResponse,
} from '../../../models';
import { PickUpPoint } from '../../../models/pickupPoints.models';
import { BuilderType, InvalidationTag, mlkOnQueryStarted } from '../../utils';

export const buildGetOrders = (builder: BuilderType) =>
  builder.query<GetOrdersResponse, undefined>({
    onQueryStarted: mlkOnQueryStarted,
    query: () => `/orders`,
    providesTags: () => [{ type: InvalidationTag.Order }],
  });

export const buildGetOrder = (builder: BuilderType) =>
  builder.query<Order, GetOrderRequest>({
    onQueryStarted: mlkOnQueryStarted,
    query: ({ orderId, isNoAssign }) =>
      `/orders/${orderId}${isNoAssign ? '?filter=noassign' : ''}`,
    providesTags: () => [{ type: InvalidationTag.Order }],
  });

export const buildUpsertReview = (builder: BuilderType) =>
  builder.mutation<UpsertReviewResponse, UpsertReviewBody>({
    onQueryStarted: mlkOnQueryStarted,
    query: (body) => ({
      url: '/reviews/upsert',
      method: 'POST',
      body,
    }),
    invalidatesTags: () => [{ type: InvalidationTag.Order }],
  });

export const buildGetPickUpPoints = (builder: BuilderType) =>
  builder.query<PickUpPoint[], string>({
    onQueryStarted: mlkOnQueryStarted,
    query: (orderId: string) => ({
      url: `/orders/pickupPoints/${orderId}`,
      method: 'GET',
    }),
  });

export const buildGetDriverLocation = (builder: BuilderType) =>
  builder.query<DriverLocation, string>({
    onQueryStarted: mlkOnQueryStarted,
    query: (orderId: string) => ({
      url: `/orders/driverLocation/${orderId}`,
      method: 'GET',
    }),
  });

export const buildGetServiceOptions = (builder: BuilderType) =>
  builder.query<GetServiceOptionsResponse, string>({
    onQueryStarted: mlkOnQueryStarted,
    query: (mlkId: string) => ({
      url: `/orders/${mlkId}/serviceOptions`,
      method: 'GET',
    }),
  });

export const buildUpdateOrder = (builder: BuilderType) =>
  builder.mutation<Order, UpdateOrderBody>({
    onQueryStarted: mlkOnQueryStarted,
    query: ({ orderId, ...body }: UpdateOrderBody) => ({
      url: `/orders/update/${orderId}`,
      method: 'PATCH',
      body,
    }),
    invalidatesTags: () => [{ type: InvalidationTag.Order }],
  });

export const buildRequestSupport = (builder: BuilderType) =>
  builder.mutation<{}, RequestSupportBody>({
    onQueryStarted: mlkOnQueryStarted,
    query: (body: RequestSupportBody) => ({
      url: `/user/requestSupport`,
      method: 'POST',
      body,
    }),
  });
